module.exports = __webpack_public_path__ + "static/media/filecsv.a6910ad1.svg";